// Lazy images without dimensions grow after the initial hash jump and push the target down.
// Keep the target aligned while the page settles; stop as soon as the user scrolls.
const id = decodeURIComponent(location.hash.slice(1));
const target = id && document.getElementById(id);

if (target) {
  const events = ["wheel", "touchstart", "keydown", "pointerdown"];
  const observer = new ResizeObserver(() =>
    target.scrollIntoView({ behavior: "instant" }),
  );
  const stop = () => {
    observer.disconnect();
    events.forEach((e) => removeEventListener(e, stop));
  };

  observer.observe(document.body);
  events.forEach((e) => addEventListener(e, stop, { passive: true }));
  setTimeout(stop, 5000);
}
